// Visible toast that fires whenever a firm-settings write fails.
//
// Before this existed, setFirmSetting() failures went only to console.
// Combined with optimistic cache updates that immediately showed the new
// value in the UI, that meant a write could silently drop and the user
// would only discover it on a future hard-refresh — sometimes weeks
// later. That's exactly what wiped Adam's LinkedIn Posts schedule
// between May 15 and Jun 2, 2026.
//
// The banner stays visible until the user dismisses it, surfaces the
// failing keys, and tells them the change DID NOT save so they can
// retry. Style matches the rose/warn palette already in use.

import { useEffect, useState } from 'react';
import { onFirmSettingsWriteError } from '../../utils/firmSettings';

export default function FirmSettingsErrorBanner() {
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    return onFirmSettingsWriteError((detail) => {
      setErrors(prev => [
        ...prev,
        { id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`, ...detail },
      ]);
    });
  }, []);

  if (errors.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 max-w-md">
      {errors.map(e => (
        <div
          key={e.id}
          className="bg-white border-l-4 border-rose rounded-[4px] shadow-[0_4px_12px_rgba(0,0,0,0.15)] p-4"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex-1 min-w-0">
              <div className="text-[12px] font-bold text-rose mb-1">
                Setting not saved
              </div>
              <div className="text-[12px] text-navy">
                Your change did not persist to the server. The on-screen value
                may be stale — refresh to confirm what's actually saved.
              </div>
              <div className="text-[10px] text-[#888] mt-2 font-mono">
                {e.kind === 'http'
                  ? `HTTP ${e.status} on ${(e.keys || []).join(', ')}`
                  : `network: ${e.message} on ${(e.keys || []).join(', ')}`}
              </div>
            </div>
            <button
              onClick={() => setErrors(prev => prev.filter(x => x.id !== e.id))}
              className="text-[#888] hover:text-navy text-[14px] leading-none"
              title="Dismiss"
            >
              ×
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
